var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#F7F8FA",
    stroke: "#3D7AB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4595 18.6625L15.9281 18.664H15.9115H15.91C15.4066 18.664 15 19.0722 15 19.5755C15 20.0804 15.4096 20.49 15.913 20.49L33.4594 20.4885L33.4595 18.6625ZM39.332 15H37.2793C35.8342 15.0045 34.6643 16.1775 34.6643 17.6226V21.5286C34.6643 22.9736 35.8342 24.1466 37.2793 24.1511H39.332C40.7771 24.1466 41.947 22.9736 41.947 21.5286L41.9455 20.4901L44.2144 20.4886C44.7192 20.4886 45.1274 20.0805 45.1274 19.5756C45.1274 19.0707 44.7192 18.6611 44.2144 18.6611H41.947V17.6226C41.947 16.1776 40.7771 15.0045 39.332 15ZM27.7034 29.0862L27.7049 30.9137H44.2143C44.7191 30.9137 45.1273 30.5056 45.1273 30.0007C45.1273 29.4958 44.7191 29.0877 44.2158 29.0877L27.7034 29.0862ZM21.8308 25.4252C20.3858 25.4282 19.2158 26.6012 19.2158 28.0478V29.0877L15.913 29.0862C15.4097 29.0862 15 29.4958 15 29.9992C15 30.5041 15.4082 30.9137 15.913 30.9137H19.2158V31.9522C19.2158 33.3987 20.3858 34.5717 21.8308 34.5762H23.8851C25.3301 34.5717 26.5001 33.3987 26.5001 31.9537V28.0477C26.5001 26.6011 25.3301 25.4281 23.8851 25.4251L21.8308 25.4252ZM15.913 39.5114C15.4082 39.5114 15 39.9195 15 40.4244C15 40.9293 15.4082 41.3374 15.913 41.3374L28.8035 41.3389V39.5114H15.913ZM32.6236 35.8489V35.8504C31.1785 35.8534 30.0086 37.0264 30.0086 38.4714V42.3774C30.0086 43.824 31.1785 44.9955 32.6236 45H34.6763C36.1214 44.9955 37.2913 43.824 37.2913 42.3774V41.339H44.2145C44.7194 41.339 45.1275 40.9293 45.1275 40.4245C45.1275 39.9211 44.7194 39.5115 44.216 39.5115H37.2913V38.4715C37.2913 37.0264 36.1214 35.8535 34.6763 35.849L32.6236 35.8489Z",
    fill: "#3D7AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagButton);
export default __webpack_public_path__ + "static/media/tagButton.f8c23249d132563ebec6565db03e9653.svg";
export { ForwardRef as ReactComponent };